// The new UI's fonts (Inter, IBM Plex Mono), loaded once and only when the new UI is on.
const FONTS_ID = 'apw2-fonts';

export function ensureFonts() {
	if (typeof document === 'undefined' || document.getElementById(FONTS_ID)) return;
	const link = document.createElement('link');
	link.id = FONTS_ID;
	link.rel = 'stylesheet';
	link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500;600&display=swap';
	document.head.appendChild(link);
}
